import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserSignedInPayloadInterface, LoginStageChangedPayloadInterface } from './interfaces';
import { LoginStage, NavigationPages } from '@ax/constants';
import { navigationSlice } from '../navigation';
export type * from './interfaces';

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    loginStage: LoginStage.Initialization,
  },
  extraReducers: (builder) => {
    builder.addCase(navigationSlice.actions.pageNavigationSucceeded, (_, action) => {
      if (action.payload.previous === NavigationPages.Login) {
        return { loginStage: LoginStage.Initialization };
      }
    });
  },
  reducers: {
    userSignedIn(state, _: PayloadAction<UserSignedInPayloadInterface>) {
      return { ...state };
    },
    userSignedOut(state, _: PayloadAction) {
      return {
        ...state,
        loginStage: LoginStage.Initialization,
      };
    },
    loginStageChanged(state, action: PayloadAction<LoginStageChangedPayloadInterface>) {
      return { ...state, loginStage: action.payload.stage };
    },
    signInCompleted(state, _: PayloadAction) {
      return { ...state };
    },
    passcodeLoginAttemptsExceeded(state, _: PayloadAction) {
      return { ...state };
    },
    logoutRequested(state, _: PayloadAction) {
      return {
        ...state,
        loading: true,
      };
    },
    logoutSucceeded(state, _: PayloadAction) {
      return {
        ...state,
        resetSession: false,
        loading: false,
      };
    },
    logoutFailed(state, action: PayloadAction<unknown>) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    resetPasscodeSession(state, _: PayloadAction) {
      return {
        ...state,
        resetSession: true,
      };
    },
  },
});

export const {
  userSignedIn,
  loginStageChanged,
  userSignedOut,
  passcodeLoginAttemptsExceeded,
  signInCompleted,
} = authSlice.actions;
